// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { ModuleOut } from './moduleOut.zod.ts';
import { RoleOut } from './roleOut.zod.ts';

export const PermissionMatrixOut = zod.object({
  "modules": zod.array(ModuleOut),
  "roles": zod.array(RoleOut)
});

export type PermissionMatrixOut = zod.input<typeof PermissionMatrixOut>;
export type PermissionMatrixOutOutput = zod.output<typeof PermissionMatrixOut>;
